module.exports = __webpack_public_path__ + "static/media/my-account-bg.4f8d8435.jpg";